import { HOSPITALISATION_STATUS } from './../../objects/hospitalisationStatus';
import { environment } from './../../../../environments/environment';
import { DOCUMENT } from '@angular/common';
import { AGE_GROUPS } from './../../objects/ageGroup';
import { EventsService } from './../../../shared/services/events/events.service';
import { UtilService } from './../../../shared/services/util/util.service';
import { CampaignService } from './../../../shared/services/campaign/campaign.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import { HOSPITAL_STATIC_OPTIONS } from '../../objects/algoliaStaticOptions';
import { VariablesService } from 'src/app/shared/services';

interface IAlgoliaElement {
  full_name?: string;
  id?: number;
  type?: string;
}

@Component({
  selector: 'app-advance-detail',
  templateUrl: './advance-detail.component.html',
  styleUrls: ['./advance-detail.component.scss']
})
export class AdvanceDetailComponent implements OnInit, OnChanges {

  type = 'personal';
  advanceForm: FormGroup;
  beneficiaryname: FormControl;
  ageGroup = AGE_GROUPS;
  hospitalisationStatusData = HOSPITALISATION_STATUS;
  beneficiaryage: FormControl;
  hospitalisationStatus: FormControl;
  selectedDisease;
  selectedHospital;
  patientNumber: FormControl;
  city: FormControl;
  selectedHS = '';
  noHospitalisationObj: IAlgoliaElement = {};
  filteredDiseaseOptions = [];
  filteredHospitalOptions = [];
  isLoading = false;
  @Input() info;
  @Input() draft; // : ICampaign;
  @Input() param;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  askpatientNumber = false;
  selectedAge;
  address;
  extn;
  checkCountry = true;
  medicalConfig = {
    // searchClient: algoliasearch(environment.algolia.id, environment.algolia.key),
    // indexName: environment.algolia.disease.index,
    searchClient: instantMeiliSearch(
      environment.meilisearch.host,
      environment.meilisearch.key,
      {
        // paginationTotalHits: 20
      }
    ),
    indexName: environment.meilisearch.disease.index,
    searchFunction: (helper) => {
      helper.search();
    },
  };
  hospitalConfig = {
    // searchClient: algoliasearch(environment.algolia.id, environment.algolia.key),
    // indexName: environment.algolia.hospital.index,
    searchClient: instantMeiliSearch(
      environment.meilisearch.host,
      environment.meilisearch.key,
      {
        // paginationTotalHits: 20
      }
    ),
    indexName: environment.meilisearch.hospital.index,
    searchFunction: (helper) => {
      helper.search();
    },
  };
  @Output() searchedQuery = new EventEmitter();

  constructor(
    private campaignService: CampaignService,
    private util: UtilService,
    private events: EventsService,
    private actRoute: ActivatedRoute,
    private vars: VariablesService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.getDraft();
  }

  ngOnInit() {
    this.getNoHSRequired();
    this.initForm();
    this.getPhoneExtn();
  }

  ngOnChanges() {
    if (this.selectedAge) {
      this.onAgeSelection(this.selectedAge);
    }
  }

  getNoHSRequired() {
    HOSPITAL_STATIC_OPTIONS.forEach(element => {
      if (element.type === 'noHospitalisationRequired') {
        this.noHospitalisationObj = element;
      }
    });
  }

  getPhoneExtn() {
    this.util.number$.subscribe(res => this.extn = res.extn);
  }

  /**
   * Get draft details
   */
  getDraft() {
    this.type = this.actRoute.snapshot.queryParams['type'];
    this.vars.draftObs.subscribe((res) => {
      this.draft = res;
      this.patchForm(res);
    });
  }

  /**Patch form */
  patchForm(data) {
    if (data.hospital) {
      data.hospital.full_name = data.hospital.info_1;
      data.hospital.id = data.hospital.info_2;
    }
    if (data.disease) {
      data.disease.name = data.disease.info_1;
      data.disease.id = data.disease.info_2;
    }
    this.advanceForm.patchValue({
      'beneficiaryage': data.beneficiaryage ? data.beneficiaryage.info_1 : '',
      'hospitalisationStatus': '',
      'selectedHospital': data.hospital ? data.hospital : '',
      'selectedDisease': data.disease ? data.disease : '',
    });
    if (data.hospital && data.hospital.info_1 === 'Does not require hospitalisation') {
      this.onHSSelection(data.hospital.info_1);
    }
    if (data.hospital && data.hospital.info_3) {
      this.patchhospitalisationStatus(data.hospital.info_3);
    }
    if (data.beneficiaryrelation) {
      this.advanceForm.patchValue({
        'beneficiaryname': data.beneficiaryname ? data.beneficiaryname.info_1 : ''
      });
      if (data.beneficiaryrelation.info_1 === 'Twins') {
        this.info.patient.placeholder = 'Name of twins';
        this.info.patient.hint = `Twins names should be '&' separated`;
        this.beneficiaryname.setValidators([Validators.pattern('^([a-zA-Z]{3,}[ \&]+[a-zA-Z]{3,})*$')]);
      }
    } else {
      this.advanceForm.patchValue({ // Prefill name for self relation
        'beneficiaryname': data.owner.full_name ? data.owner.full_name : ''
      });
    }
    if (data.beneficiaryage) {
      this.onAgeSelection(data.beneficiaryage.info_1);
      if (this.askpatientNumber) {
        this.checkCountry = false;
        if (this.draft.patient_number.info_1.substr(0, 1) === '+') {
          this.advanceForm.patchValue({
            'patientNumber': this.draft.patient_number.info_1
          });
        } else {
          this.advanceForm.patchValue({
            'patientNumber': this.draft.patient_number.info_2 + this.draft.patient_number.info_1
          });
        }
      }
    }
    if (data.address_1 || data.address_2 || data.address_3) {
      let formattedAddress = '';
      [1, 2, 3].forEach(item => {
        formattedAddress = formattedAddress + (data[`address_${item}`] ? data[`address_${item}`] + (item < 3 ? ', ' : '') : '');
      });
      this.city.patchValue(formattedAddress);
    }
    this.address = {
      address_1: data.address_1,
      address_2: data.address_2,
      address_3: data.address_3,
    };
  }

  initForm() {
    this.advanceForm = new FormGroup({
      beneficiaryname: this.beneficiaryname = new FormControl('', [Validators.required, Validators.minLength(3)]),
      beneficiaryage: this.beneficiaryage = new FormControl('', Validators.required),
      selectedDisease: this.selectedDisease = new FormControl('', [Validators.required]),
      selectedHospital: this.selectedHospital = new FormControl('', [Validators.required]),
      city: this.city = new FormControl('', [Validators.required]),
      hospitalisationStatus: this.hospitalisationStatus = new FormControl('', Validators.required),
    });
  }

  onAgeSelection(data) {
    this.selectedAge = data;
    const lang = this.util.storage.get('language');
    if (this.draft?.beneficiaryrelation) {
      if (this.info.guardian_relations.hasOwnProperty(this.draft.beneficiaryrelation.info_1)) {
        this.askpatientNumber = this.info.guardian_relations[this.draft.beneficiaryrelation.info_1][data];
      }
    }
    this.advanceForm.removeControl('patientNumber');
    if (this.askpatientNumber) {
      this.patientNumber = new FormControl('', [Validators.required]);
      this.advanceForm.addControl('patientNumber', this.patientNumber);
    } else {
      this.advanceForm.removeControl('patientNumber');
    }
  }

  onHSSelection(data) {
    this.selectedHS = data;
    if (data === 'Does not require hospitalisation') {
      this.advanceForm.patchValue({
        'selectedHospital': this.noHospitalisationObj,
      });
      this.patchhospitalisationStatus(data);
    } else {
      this.advanceForm.patchValue({
        'selectedHospital': ''
      });
    }
  }

  patchhospitalisationStatus(data) {
    this.selectedHS = data;
    this.advanceForm.patchValue({
      'hospitalisationStatus': data
    });
  }

  /**Submit form */
  submit() {
    // this.autocomplete.closePanel();
    if (typeof this.selectedDisease.value !== 'object') {
      this.selectedDisease.setErrors({ 'notFromList': true });
    }
    if (typeof this.selectedHospital.value !== 'object') {
      this.selectedHospital.setErrors({ 'notFromList': true });
    }
    if (this.advanceForm.valid) {
      this.isLoading = true;
      const payload: any = {
        'disease': { 'info_type': 'disease', 'entity_type': 'campaign', 'info_1': this.selectedDisease.value.name, 'info_2': this.selectedDisease.value.id },
        'beneficiaryname': { 'info_type': 'beneficiary_name', 'entity_type': 'campaign', 'info_1': this.beneficiaryname.value },
        'beneficiaryage': { 'info_type': 'beneficiary_age', 'entity_type': 'campaign', 'info_1': this.beneficiaryage.value },
        'hospital': { 'info_type': 'hospital', 'entity_type': 'campaign', 'info_1': this.selectedHospital.value.full_name, 'info_2': this.selectedHospital.value.id }
      };
      if (this.selectedHS !== 'Does not require hospitalisation') {
        payload.hospital['info_3'] = this.selectedHS;
      }
      if (this.askpatientNumber) {
        if (this.patientNumber.value.substr(0, 1) === '+') {
          this.patientNumber.value.replace(this.extn, '');
        }
        this.patientNumber.value.split(' ').join('');
        this.util.storage.checkFromSession(
          'askpatientNumber',
          { phone_1: this.patientNumber.value, extension: this.extn, askpatientNumber: this.askpatientNumber }
        );
        payload['patientNumber'] = {
          info_type: 'patient_number',
          info_1: this.patientNumber.value,
          info_2: this.extn,
          entity_type: 'campaign'
        };
        // Set guardian phone
      } else {
        this.util.storage.deleteFromSession('askpatientNumber');
      }
      try {
        payload['address_1'] = this.address.address_1 || '';
        payload['address_2'] = this.address.address_2 || '';
        payload['address_3'] = this.address.address_3 || '';
      } catch (error) {
        console.log(error);
      }
      this.updateCampaign(payload, this.draft.id);
    } else {
      this.util.checkValidForm(this.advanceForm);
    }
  }

  /**Update Campaign
   * @param payload required data for updating campaign
  */
  updateCampaign(payload, id) {
    this.campaignService.updateCampaign(payload, id).subscribe(
      (res: any) => {
        this.campaignService.getCampaignDraft(id).subscribe(
          (response: any) => {
            this.isLoading = false;
            this.draft = response.data;
            this.vars.draftObs.next(response.data);
            this.util.addObject(res.data, this.draft);
            this.util.navigateToMedicalForm('desc', this.type, this.draft.id);
            this.sendDraftLead();
          }
        );
        this.gtmPush();
        this.sendSystemEvent();
      }
    );
  }

  submitButton() {
    this.document.getElementById('submitBtn2').click();
  }

  /**
   * ALL THE EVENT TRACKING FUNCTIONS
   */
  sendSystemEvent() {
    const payload = {
      eventName: 'start_a_campaign_step2_completed',
      event_type: 'campaign',
      page_name: 'Start a Campaign step2',
      info_1: 'type',
      info_2: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      info_3: this.util.storage.get('language') || 'English'
    };
    if (this.draft?.id) {
      payload['event_type_id'] = this.draft?.id;
    }

    this.events.systemEventPush(payload);
  }
  /**GTM data push */
  gtmPush() {
    const dataPush = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      eventLabel: 'step2_completed',
      Campaign_cause_id: this.draft.cause_id,
      Campaign_id: this.draft.id,
      Campaign_Type: this.util.getCampaignTypeFromId(this.draft.parent_cause_id)
    };
    this.events.gtmPush(dataPush);
  }

  getPlace(event) {
    this.address = event;
  }

  sendDraftLead() {
    const payload: any = {
      type: 'P - Draft campaign (Step 2)',
      subject: 'Draft campaign',
      patient_name: this.beneficiaryname.value,
      age: this.beneficiaryage.value,
      medical_condition: this.selectedDisease?.value?.name,
      hospitalization_status: this.hospitalisationStatus.value,
      hospital_name: this.selectedHospital?.value?.full_name,
      city: this.address?.address_1 || this.address,
      parent_cause_id: this.draft?.parent_cause_id,
      cause_id: this.draft?.cause_id,
      cause_name: this.draft?.cause?.info_1,
      CID: this.draft?.id
    };
    this.events.sendLead(payload);
  }

}
